import v2Axios from "../v2Axios";
import { CONFIG } from "../../config";
import { toNonNegativeId, toPositiveId } from "../../utils/ids";
// courseId must be the real parent course id: the backend checks enrolment against it, so
// 0/missing is never sent. subcourseId is 0 only for a normal (non-subcourse) course.
export const downloadBookURLService = async (courseId, subcourseId) => {
	const parentCourseId = toPositiveId(courseId);
	const subCourseId = toNonNegativeId(subcourseId);
	if (parentCourseId === null || subCourseId === null) {
		return [];
	}
	try {
		const response = await v2Axios.get(
			`${CONFIG.COURSEURL}/api/v2/books/get-requiredbook/` +
				parentCourseId +
				`/` +
				subCourseId
		);
		return response.data;
	} catch (error) {
		// returning blank array after getting server and internet error
		return [];
	}
};
